import { PagesizeType } from '../../service/pagination/pagesize-type';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { Rsvp } from '../../models/rsvp';
import { OnyxEvent } from '../../models/event';
import { TransientTableComponent } from '../transient-table/transient-table.component';
import { TransientReservationStore } from '../../service/transient-reservation-store';
import { TransientSearchComponent } from '../transient-search/transient-search.component';
import { ReservationCompareStore } from '../../service/reservation-compare-store';
import { FlashMessagesService } from '../../../shared/flash-messages/service/flash.messages.service';
import { TransientReservationSearchParameters } from '../../models/transient-reservation-search-params';
import { TransientReservation } from '../../models/reservation';
import { Page } from '../../../shared/models/page';
import { Constants } from '../../../shared/constants';
import { AuthenticationStore } from 'app/permission/services/authentication.store';
import { EventUtils } from 'app/event/utils/event-utils';

@Component({
  selector: 'pioneer-transient-modal',
  templateUrl: './transient-modal.component.html'
})
export class TransientModalComponent implements OnInit {

  @ViewChild(ModalDirective)
  public transientModal: ModalDirective;

  @ViewChild(TransientTableComponent)
  public transientTableComponent: TransientTableComponent;

  @ViewChild(TransientSearchComponent)
  public transientSearchComponent: TransientSearchComponent;

  @Output()
  public closed = new EventEmitter();

  @Input()
  public config = {
    backdrop: 'static',
    keyboard: false
  };

  @Input()
  event: OnyxEvent;

  rsvp: Rsvp;

  searchResults: Page<TransientReservation>;

  pagesizeType = PagesizeType.TRANSIENT_RESERVATIONS;

  constructor(private transientReservationStore: TransientReservationStore,
    private reservationCompareStore: ReservationCompareStore,
    private flashMessagesService: FlashMessagesService,
    private authenticationStore: AuthenticationStore) { }

  ngOnInit() {
  }

  public open(rsvp: Rsvp): void {
    if (!this.event) {
      throw new Error('The "event" attribute must be specified to use the TransientModalComponent component');
    }
    if (!rsvp) {
      throw new Error('The "rsvp" parameter must be specified to use the TransientModalComponent component');
    } else {

      this.rsvp = rsvp;

      this.transientSearchComponent.initSearchForm(rsvp);

      const _startDate = EventUtils.getEventStartDate(this.event, this.authenticationStore.isAgencyUser());
      const _endDate = EventUtils.getEventEndDate(this.event, this.authenticationStore.isAgencyUser());

      const defaultParams = new TransientReservationSearchParameters({
        eventId: this.event.eventId,
        eventPartyId: this.event.eventProperty.eventPartyId,
        minCheckInDate: _startDate,
        maxCheckOutDate: _endDate,
        firstName: rsvp.firstName,
        lastName: rsvp.lastName
      });

      this.transientSearchComponent.refreshTransientReservations(Constants.SEARCH_DEFAULT_PAGE, defaultParams);
      this.transientModal.show();

    }

  }

  public accept(): void {
    this.transientTableComponent.obtainTransientReservationSelected().subscribe(transientReservation => {
      this.transientReservationStore.linkTransientReservationsToEvent([transientReservation.eventReservationId],
        this.event.eventProperty.eventPartyId)
        .subscribe(() => {
          this.flashMessagesService.success('MESSAGES.SUCCESS.TRANSIENT_RESERVATION_LINKED');
          if (this.isMultiVendor()) {
            this.reservationCompareStore.refreshCurrentRsvpList(this.event.eventId);
          } else {
            this.reservationCompareStore.refreshCurrentRsvpListByParty(this.event.eventId, this.event.eventProperty.eventPartyId);
          }
          this.close(true);
        });
    });
  }

  public disableLinkButton(): boolean {
    let disable = false;
    if (this.transientTableComponent && this.transientTableComponent.searchResults) {
        disable = this.transientTableComponent.searchResults.totalElements === 0;
    }
    return disable;
  }

  private close(value: boolean): void {
    this.transientTableComponent.cleanSelected();
    this.closed.emit(value);
    this.transientModal.hide();
  }

  public cancel(): void {
    this.close(false);
  }

  onHasSearched() {

    const obs$ = this.transientReservationStore.searchResults.take(1);

    obs$.subscribe((page: Page<TransientReservation>) => {
      this.searchResults = page;
    });

  }

  onRefreshList(page: number) {
    this.transientSearchComponent.refreshTransientReservations(page);
  }

  isMultiVendor() {
    return this.authenticationStore.hasPermission('MultiVendor');
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/reservations/transient-modal/transient-modal.component.ts